'use client';

import { CheckIcon, ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

import { getLogger } from '@/shared/utils/logger/client';

const logger = getLogger();

type CopyButtonProps = {
	text: string;
	className?: string;
	title?: string;
	label?: string;
};

export function CopyButton({
	text,
	className = 'ml-1 rounded p-0.5 text-gray-3 transition-colors hover:bg-gray-4 hover:text-gray-1',
	title = 'Копировать',
	label,
}: CopyButtonProps) {
	const [isCopied, setIsCopied] = useState(false);

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(text);
			setIsCopied(true);
			setTimeout(() => setIsCopied(false), 2000);
		} catch (err) {
			logger.error('Не удалось скопировать в буфер', err);
		}
	};

	return (
		<button
			type="button"
			onClick={handleCopy}
			className={className}
			title={title}
			aria-label={label ? undefined : title}
		>
			{isCopied ? (
				<CheckIcon className="h-3.5 w-3.5 text-green" />
			) : (
				<ClipboardDocumentIcon className="h-3.5 w-3.5" />
			)}
			{label && <span>{isCopied ? 'Скопировано' : label}</span>}
		</button>
	);
}
